import { GetterTree } from "vuex";
import { RootState } from "../types";
import { BddState } from "./types";

export const getters: GetterTree<BddState, RootState> = {};
